import _ from "underscore";
import TemplateView from "./TemplateView";
import {clamp} from "./clamp";
import {defer} from './atUtils'
import {getInstance as tooltip} from './SimpleSingletonTooltip'

/**
 * Component with text truncated by specified line count with ellipsis.
 *  Need line-height property to be defined in container element.
 */
export default class TruncatedTextView extends TemplateView{
    constructor({
        text,
        lineCount = 1,
        ellipsis,
    } = {}){
        super();
        this.text = text;
        this.lineCount = lineCount;
        this.ellipsis = ellipsis;
        this.truncated = false;
    }

    templateHtml(){
        return "<div class='wrapper'/>"
    }

    afterRender() {
        this._update()
    }

    _update() {
        this.$el.text((!_.isNull(this.text)) ? this.text : "");
        defer(() => {
            this.truncated = clamp(this.$el[0], {lineCount: this.lineCount, ellipsis: this.ellipsis});
            if (this.truncated) {
                tooltip().subscribeToMouseEvents(this.$el, () => {
                    tooltip().setState({
                        text: this.text,
                        extraClass: 'truncatedTextViewTooltip',
                    })
                })
            }
        }, this)
    }

    setText(text){
        this.text = text;
        this._update();
    }

    isTruncated(){
        return this.truncated;
    }
}


// WEBPACK FOOTER //
// ./web/js/TruncatedTextView.js